import { sendRequest } from "@/api/clients/axios";

export type OrganizationAutocompleteItem = {
  slug: string;
  name: string;
  owner: {
    id: number;
    assigneeFirstName: string | null;
    assigneeLastName: string | null;
    assigneeEmail: string | null;
    assigneePhone: string | null;
    siret: string | null;
  } | null;
};

const DEFAULT_LIMIT = 20;

export async function getOrganizationsAutocomplete(
  q: string,
  limit = DEFAULT_LIMIT
): Promise<OrganizationAutocompleteItem[]> {
  const res = await sendRequest<undefined, OrganizationAutocompleteItem[]>(
    "get",
    "organizations/autocomplete",
    undefined,
    {
      params: { q: q.trim(), limit },
    }
  );
  if (res.status !== 200) {
    return [];
  }
  return res.data ?? [];
}
